import { TableCell, TableRow } from '@mui/material';
import React from 'react'

function RelationShipItems({relationShip,relation,ageRangeList,leftLabel,sumType,bg=''}) {
    let countTotal=0;
    return (
        <TableRow>
            <TableCell style={{ padding: 0 }}>
                <div className={`tableHeads alignItemLeft ${bg}`}>{leftLabel}</div>
            </TableCell>
            {relationShip[relation].map((ageGroup) => {
                return (<>{
                    ageRangeList.map((ageRange) => {
                        const details = ageGroup[ageRange];
                        countTotal += parseFloat(details[sumType]);
                        return (<TableCell style={{ padding: 0 }} >
                            <div className={`tableHeads ${bg}`}>{details[sumType]}</div>
                        </TableCell>)
                    })
                }</>)


            })}

            <TableCell style={{ padding: 0 }}>
                <div className={`tableHeads ${bg}`}>{countTotal}</div>
            </TableCell>
        </TableRow>
    )
}

export default RelationShipItems